"use client"

import { useEffect, useMemo, useState } from "react"
import ThemeContext from "context/ThemeContext"
import { Theme, Variant } from "types/theme"
import { LS_THEME_KEY, setWindowTheme, setWindowVariant, THEMES, VARIANTS } from "utils/theme"

interface ThemeProviderProps {
  children: React.ReactNode
}

export default function ThemeProvider({ children }: ThemeProviderProps) {
  const [theme, setTheme] = useState<Theme>(() => {
    if (typeof window !== "undefined") {
      return (localStorage.getItem(LS_THEME_KEY) as Theme) || THEMES.DARK
    }
    return THEMES.DARK
  })
  const [variant, setVariant] = useState<Variant>(VARIANTS.BLUE)

  const value = useMemo(() => ({ theme, setTheme, variant, setVariant }), [theme, variant])

  useEffect(() => {
    setTheme(theme)
    setWindowTheme(theme)
    localStorage.setItem(LS_THEME_KEY, theme)
  }, [theme])

  useEffect(() => {
    setWindowVariant(variant)
  }, [variant])

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
}
